import * as React from "react";
import { Capacitor } from "@capacitor/core";

const MOBILE_BREAKPOINT = 768;

const isSmallViewport = () => {
  if (typeof window === "undefined") return false;
  return window.innerWidth < MOBILE_BREAKPOINT;
};

// Viewport-only detection. We intentionally do NOT sniff the user-agent here:
// Chrome DevTools' responsive mode (and some browser extensions) inject a
// mobile UA string even on large screens, which previously caused desktop
// users to see the "This website is meant for Desktop" prompt and made the
// page appear stuck/blank while loading.
const detectMobileWeb = () => isSmallViewport();

export function useIsMobile() {
  const isNativePlatform = Capacitor.isNativePlatform();

  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (isNativePlatform) return true;
    return detectMobileWeb();
  });

  React.useEffect(() => {
    if (isNativePlatform) {
      setIsMobile(true);
      return;
    }

    const onChange = () => setIsMobile(detectMobileWeb());
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    mql.addEventListener("change", onChange);
    window.addEventListener("orientationchange", onChange);
    onChange();

    return () => {
      mql.removeEventListener("change", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, [isNativePlatform]);

  return isMobile;
}
